import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'creditCard'
})
export class CreditCardPipe implements PipeTransform {

  creditCardTypes = new Map<string, string>();

  constructor() { 
    this.creditCardTypes.set("Visa", "Visa").set("Mastercard", "Mastercard").set("Discover", "Discover").set("Amex", "American Express");
  }

  transform(value: string | undefined): string | undefined {
    if(!value || !this.creditCardTypes.get(value)) {
      return value;
    }
    return this.creditCardTypes.get(value);
  }

}
